import React, { useState } from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius, elevation, motion } from '../tokens';

const SectionCard = ({
  title,
  subtitle,
  accent,
  action,
  collapsible = false,
  defaultOpen = true,
  padded = true,
  compact = false,
  children,
  style = {},
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section
      style={{
        background: colors.surface,
        border: `1px solid ${colors.border}`,
        borderLeft: accent ? `3px solid ${accent}` : `1px solid ${colors.border}`,
        borderRadius: radius.md,
        boxShadow: elevation.card,
        marginBottom: space[4],
        overflow: 'hidden',
        ...style,
      }}
    >
      {(title || action || collapsible) && (
        <header
          onClick={collapsible ? () => setOpen(!open) : undefined}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: compact
              ? `${space[2]}px ${space[4]}px`
              : `${space[3]}px ${space[5]}px`,
            borderBottom: open && children ? `1px solid ${colors.border}` : 'none',
            cursor: collapsible ? 'pointer' : 'default',
            userSelect: 'none',
            gap: space[3],
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: space[2], minWidth: 0 }}>
            {collapsible && (
              <Icon
                category="utility"
                name={open ? 'chevrondown' : 'chevronright'}
                size="xx-small"
                style={{ fill: colors.textTertiary, flexShrink: 0 }}
              />
            )}
            <div style={{ minWidth: 0 }}>
              {title && (
                <h3 style={{
                  ...(compact ? type.label : type.h3),
                  color: compact ? colors.textTertiary : colors.textPrimary,
                  margin: 0,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                  {title}
                </h3>
              )}
              {subtitle && (
                <p style={{
                  ...type.small,
                  color: colors.textTertiary,
                  margin: `${space[1]}px 0 0 0`,
                }}>
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {action && (
            <div onClick={e => e.stopPropagation()} style={{ flexShrink: 0 }}>
              {action}
            </div>
          )}
        </header>
      )}
      {open && (
        <div style={{
          padding: padded ? (compact ? space[3] : space[5]) : 0,
          transition: `padding ${motion.base}`,
        }}>
          {children}
        </div>
      )}
    </section>
  );
};

export default SectionCard;
